import { Helmet } from 'react-helmet-async';

interface ComingSoonPageProps {
  title: string;
  description: string;
}

export default function ComingSoonPage({ title, description }: ComingSoonPageProps) {
  return (
    <div className="layout-container py-12 pt-28 max-w-3xl mx-auto">
      <Helmet>
        <title>{title} | AzureCalc.uk</title>
      </Helmet>

      <div className="mb-10">
        <h1 className="text-4xl font-extrabold tracking-tight mb-4">{title}</h1>
        <p className="text-xl text-zinc-400 max-w-2xl leading-relaxed">{description}</p>
      </div>

      <div className="bg-surface-container-high ghost-border rounded-lg p-8 flex flex-col items-center gap-4 text-center">
        <span className="material-symbols-outlined text-5xl text-primary" style={{ fontVariationSettings: "'FILL' 0" }}>
          construction
        </span>
        <p className="text-lg font-semibold text-on-surface">Coming in the next update</p>
        <p className="text-sm text-outline max-w-md">
          This feature is on the roadmap. Check back soon.
        </p>
      </div>
    </div>
  );
}
